var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    [
      _vm.pageData.viewMode === "list"
        ? _c("common-table", { ref: "table" })
        : _vm._e(),
      _vm.pageData.viewMode === "info"
        ? _c("common-form", {
            ref: "form",
            scopedSlots: _vm._u(
              [
                {
                  key: "endButton",
                  fn: function () {
                    return [_vm._t("endButton")]
                  },
                  proxy: true,
                },
                {
                  key: "endForm",
                  fn: function () {
                    return [_vm._t("endForm")]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }